import { FC } from 'react';
import { useIntl } from 'react-intl';

import { PageTitle } from '../../../_metronic/layout/core';
import { QuickSale } from '../../modules/quick-sale';
import { usePathProps } from '../../modules/user-profile/hooks/usePathProps';

const QuickSalePage: FC = () => {
  const intl = useIntl();
  usePathProps();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'menu.quickSale' })}
      </PageTitle>
      <QuickSale />
    </>
  );
};

export { QuickSalePage };
